import { render, staticRenderFns } from "./ImsArbsList.vue?vue&type=template&id=0b61f8e2&scoped=true&"
import script from "./ImsArbsList.vue?vue&type=script&lang=js&"
export * from "./ImsArbsList.vue?vue&type=script&lang=js&"
import style0 from "./ImsArbsList.vue?vue&type=style&index=0&id=0b61f8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61f8e2",
  null
  
)

export default component.exports